
export function initSelect2(node, label) {
    // the node has been mounted in the DOM

    const select = window.cjq(node);
    select.select2({
        dropdownParent: node.parentNode,
        placeholder: label,
        searchInputPlaceholder: 'Digita per filtrare',
        allowClear: true,
        language: window.select2ItalianTranslation
    });

    select.on('select2:select', function (e) {
        node.dispatchEvent(new CustomEvent("filterSelected", {detail: e.params.data.id}));
    });
    select.on('select2:unselect', function (e) {
        node.dispatchEvent(new CustomEvent("filterUnselected", {detail: 'relevance:desc'}));
    });
    return {
        update() {
            select.change();
        },
        // runs when node has been removed from DOM
        destroy() {
            // remove event listeners
            select.off('select2:select');
            select.off('select2:unselect');

            // destroy select2 object
            select.select2('destroy');
        }
    };
}
